import { defineComponent as _defineComponent } from 'vue'
import { TourPageHeader, type AccountUser } from '@travelata-libs/travelata-frontend';
import type { ApiTour } from '@travelata-libs/travelata-frontend/dist/entities/tour';
import { computed } from 'vue';
import { useState } from 'vuex-composition-helpers';
import { nameRoutesStore } from '@ve/components/routes/common/stores/RoutesStore';
import type { IRoutesStoreState } from '@ve/components/routes/common/stores/types/IRoutesStoreState';
import type TourProductModelv2 from '@/js/common/components/tour-page/Domain/Model/TourProductModelv2';

interface LibTourPageHeaderProps {
    authData: { user: AccountUser | null; accountUrl: string };
}
interface LibTourPageHeaderEmits {
    (event: 'login'): void;
    (event: 'logout'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LibTourPageHeader',
  props: {
    authData: null
  },
  emits: ["login", "logout"],
  setup(__props: any) {




const { foundTourProductsv2 } = useState<IRoutesStoreState>(nameRoutesStore, ['foundTourProductsv2']);

function adaptTourProductToApiTour(product: TourProductModelv2): ApiTour {
    const { departureCity, resort, nights, checkInDate } = product.tour;
    const { adults, infants, kids, kidsAges = [] } = product.roomsTouristGroup;

    return {
        departureCity: typeof departureCity === 'object'
            ? { id: departureCity.id, name: departureCity.name }
            : { id: departureCity, name: '' },
        checkInDate,
        nights: { tour: nights.tour, hotel: nights.hotel },
        resort: typeof resort === 'object'
            ? { id: resort.id, name: resort.name, country: resort.country, isPopular: resort.isPopular }
            : { id: resort, name: '', country: 0, isPopular: false },
        touristGroup: { adults, infants, kids, kidsAges },
        roomGroups: product.roomGroups.map((roomGroup) => ({
            hash: roomGroup.hash,
            room: roomGroup.room,
            touristGroup: {
                adults: roomGroup.touristGroup.adults,
                infants: roomGroup.touristGroup.infants,
                kids: roomGroup.touristGroup.kids,
                kidsAges: roomGroup.touristGroup.kidsAges ?? [],
            },
        })),
        country: {
            id: product.country?.id ?? 0,
            name: product.country?.name ?? '',
            cover: product.country?.cover ?? '',
        },
    } as ApiTour;
}

const tour = computed<ApiTour | null>(() => {
    const product = foundTourProductsv2.value?.[0];
    return product ? adaptTourProductToApiTour(product) : null;
});

return { __sfc: true,foundTourProductsv2, adaptTourProductToApiTour, tour, TourPageHeader }
}

})